module.exports = __webpack_public_path__ + "static/media/kuvik.6d709315.jpg";